import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { ConditionalQuestionLabel } from 'components/ConditionalQuestion';
import generateQuestionFormName from 'utils/generateQuestionFormName';
import { questionTypes } from 'sharedParts';
import { getQuestionPropTypes } from 'sharedParts/config/blockConfig';

import TextQuestionRichText from '../../../domains/richText/components/TextQuestionRichText';
import NumericQuestionForm from './NumericQuestionForm';
import propTypeBlockStyling from '../../../domains/styling/config/editorBlock/PropTypes/blockStyling';

const NumericQuestion = ({
  block,
  block: { clientUuid, content, required },
  isCloned,
  isInPreviewMode = false,
  onAnswer,
  answer,
  styling,
  questionNumber,
}) => {
  const isConditionalQuestion = useMemo(() => !!(block.logic && block.logic.message), [block.logic]);

  return (
    <div>
      {isInPreviewMode &&
        isConditionalQuestion && <ConditionalQuestionLabel enableMessage={block.logic.message} />}
      <TextQuestionRichText
        questionNumber={questionNumber}
        content={content}
        required={required}
        styling={styling}
      />
      <NumericQuestionForm
        form={generateQuestionFormName(clientUuid, isCloned)}
        block={block}
        onSubmit={onAnswer}
        initialValues={answer}
        styling={styling}
      />
    </div>
  );
};

NumericQuestion.propTypes = {
  block: getQuestionPropTypes(questionTypes.questionNumeric).isRequired,
  isCloned: PropTypes.bool,
  isInPreviewMode: PropTypes.bool,
  onAnswer: PropTypes.func.isRequired,
  answer: PropTypes.shape({
    value: PropTypes.number,
    comments: PropTypes.string,
  }),
  styling: propTypeBlockStyling,
  questionNumber: PropTypes.number,
};

export default NumericQuestion;
